<template>
    <div class="card">
        <div v-if="isLoading" class="p-3">
            <HorizontalLinesLoader />
        </div>
        <section 
            v-else
            class="job-recommendation border-light-blue-2 border-radius-4"
        >
            <div class="job-recommendation__header-text card-header d-flex bg-light-grey-2 p-1">
                <div class="card-header__assessment-icon mr-1">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.5202 36.5889H29.1802V27.9009C32.7122 27.9009 36.9342 28.8342 36.9342 23.7722C36.9342 19.2642 32.7122 19.8696 29.1802 19.8696V11.0095H20.5202C21.7356 7.13222 21.7356 3.25488 17.2016 3.25488C12.6676 3.25488 12.7149 7.47755 12.7149 11.0089H3.60156V20.3489C6.43023 19.3022 11.3556 17.4035 11.3556 23.7989C11.3556 30.1942 5.70223 28.1862 3.60156 27.2475V36.5876H11.5816C11.5816 33.0562 11.5816 28.3329 16.3909 28.3809C20.9129 28.4256 20.5196 33.0562 20.5196 36.5876L20.5202 36.5889Z" fill="#000"/>
                    <path d="M20.0391 32.0657C21.1964 33.2223 20.7791 34.821 20.7791 36.587H29.1831V27.247C33.0604 27.937 36.5144 29.6497 36.5144 23.771C36.5144 20.239 33.1984 19.6417 29.6664 19.6417V11.209H26.9224" fill="#000"/>
                    <path d="M13.7522 11.0088H3.60156V20.3495C5.38823 18.7888 11.3556 18.1581 11.3556 23.7988C11.3556 29.4395 5.38823 28.8088 3.60156 27.2475V36.5881H12.6669C11.1069 34.8001 10.4756 28.8335 16.1169 28.8335M29.1802 27.2475V36.5881H19.5656M20.6509 11.0088H29.1802V20.3495" stroke="#4095B1" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M19.5623 36.5892C21.123 34.8019 21.7536 28.8352 16.113 28.8352M13.749 11.0099C12.1883 9.22253 11.5576 3.25586 17.1983 3.25586C22.839 3.25586 22.2083 9.22253 20.647 11.0099M29.177 27.2485C30.9643 28.8099 36.931 29.4405 36.931 23.7999C36.931 18.1592 30.9643 18.7899 29.177 20.3505" stroke="#4095B1" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div>
                    <div class="fs-16 card-header__primary-text fw-500">Job recommendation</div>
                    <p v-if="!recommendations.length" class="fw-400 fs-14 mb-0 card-header__secondary-text">No pending job recommendations</p>
                    <p v-if="recommendations.length" class="fw-400 fs-14 mb-0 card-header__secondary-text">You have {{ recommendations.length }} pending job recommendation.</p>
                </div>
            </div>
            
            <main :class="!recommendations.length ? 'd-none' : 'p-3 job-recommendation__main'">
                <div v-if="recommendations.length">
                    <div v-for="(recommendation, index) in recommendations" :key="index" class="d-flex align-items-center justify-content-between mb-2">
                        <div>
                            <p @click="goToJob(recommendation.job.id)" class="job-recommendation__job-title cursor-pointer text-dark-grey-1 mb-0 fw-500 fs-16" v-b-popover.hover.top="'Click to view this job.'">{{ recommendation.job.title }}</p>
                            <p class="text-dark-grey-1 mb-0 fw-400 fs-13">View and respond to job invite</p>
                            <p class="text-muted mb-0 fw-400 fs-13">Date: {{ $moment(recommendation.created_at).format("Do MMM, YYYY")  }}</p>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div :class="{'disable-div': isResponding, 'd-flex': true}">
                                <i @click="acceptOrDeclineRecommendation(recommendation.id, 'accept')" class="material-icons text-dark-green-1 cursor-pointer" v-b-popover.hover.top="'Accept'">done</i>
                            </div>
                            <div :class="{'disable-div': isResponding, 'd-flex': true}">
                                <i @click="acceptOrDeclineRecommendation(recommendation.id, 'decline')" class="material-icons text-danger-1 ml-4 cursor-pointer" v-b-popover.hover.top="'Decline'">close</i>
                            </div>
                            <ShrInlineLoader size="sm" v-if="isResponding && selectedResponseId === recommendation.id" class="mx-2"/>
                        </div>
                    </div>
                </div>
            </main>
        </section>
    </div>
</template>

<script>
import CandidateModel from "../../../models/CandidateModel"
import AlertService from '../../../services/AlertService';
import HorizontalLinesLoader from "../../admin/jobs/job-management/applicant-tracking-system/includes/loaders/utility/HorizontalLines.vue"

export default {
name: "JobRecommendationCard",
mixins: [CandidateModel, AlertService],
components: {
    HorizontalLinesLoader
},
data() {
    return {
        recommendations: [],
        isLoading: false,
        isResponding: false,
        isDeclining: false,
        selectedResponseId: 0,
    }
},
mounted() {
    this.getJobRecommendations();
},
methods: {
    getJobRecommendations() {
        this.isLoading = true;
        this.CandidateModel.getJobRecommendations()
        .then((resp) => {
            this.recommendations = resp.data;
        })
        .catch((e) => {
            this.$alert.toast('error', 'Error', e.message);
        })
        .finally(() => {
            this.isLoading = false
        })
    },

    acceptOrDeclineRecommendation(id, status) {
        this.showInfoPrompt(`Are you sure you want to ${status} this Job Recommendation?`, `${status === 'accept' ? 'Accept' : 'Decline'} job recommendation.`,  'Proceed')
        .then((r) => {
            if(r.isConfirmed) {
                this.isResponding = true;
                this.selectedResponseId = id;
                const recommendation_id = this.selectedResponseId;
                const payload = { status };          
                this.CandidateModel.acceptOrDeclineRecommendation(recommendation_id, payload)
                .then(r => {
                    this.$alert.toast('success', 'Success', r.message);
                    this.getJobRecommendations();
                })
                .catch((e) => {
                    this.$alert.toast('error', 'Error', e.message);
                })
                .finally(() => {
                    this.isResponding = false
                })
            }
        })
    },

    goToJob(id) {
        this.$router.push({ name: 'View.Job', params: { id: id } })
    }
}
}
</script>

<style scoped lang="scss">
.job-recommendation {
    &__main {
        height: 100%;
        max-height: 230px;
        overflow: auto;
    }
    &__job-title:hover {
        color: #296DB3 !important;
    }
}
</style>
  
  